let body = $('body');

let form = $('#form-riepilogo-ordine');

let btn = $('button.btn-send');
let btn_three = $('#proceed-to-step-three');
let btn_different_data = $("input[name='specifica-dati']");
let btn_spedizione_uguale_fatturazione = $("#spedizione_uguale_fatturazione");
let sezione_spedizione = $(".hide-spedizione-form");
let _this;

let primaVoltaCopia = 0;
let required;
let nome;
let tipo;
let valore;
let confronto_email;
let confronto_pass;
let piva = $('#inputiva');
let cfiscale = $('#inputcf');
let warning_modal = $('.warning--modal-container');
let close_warning = $('.close-warning');

let input__nazione_fat = $('.input__nazione_fat');
let input__nazione_acq = $('.input__nazione_acq');

let tipoUtenteFatCheck = $('.js-fat-tipo-utente');
let OSC_FORM = $('#OSC-FORM');
let OSC_STEPS = $('.c-toggle-div');
let OSC_SPLITPAY = $('#splitpayment');
let OSC_SHIPMENT = $('input[name=metodo_spedizione]');
let OSC_CAP = $('input[name=acq_cap]');
let OSC_STATE = $('select[name=acq_nazione]');
let OSC_PAYMENT = $('input[name=metodo_pagamento]');
let OSC_CART = $('input[name=cart]');
let OSC_USERID = $('input[name=user_id]');
let OSC_GUEST = $('input[name=guest_create]');
let OSC_UGUALI = $('input[name=uguali]');

export function init() {
	btn.on('click', checkToProceed);
	btn_spedizione_uguale_fatturazione.on('click', toggleDestinatario);

	close_warning.on('click', hideWarning);

	input__nazione_fat.change(function() {
		updateNazione(this, 'input__regione_fat');
		enableSplitPayment(this);
		enableFatturazione(this);
	});

	input__nazione_acq.change(function() {
		updateNazione(this, 'input__regione_acq', sezione_spedizione);
	});

	$(window).resize(function() {
		updateNazione(input__nazione_fat, 'input__regione_fat');
		updateNazione(input__nazione_acq, 'input__regione_acq', sezione_spedizione);
	});

	updateNazione(input__nazione_fat, 'input__regione_fat');
	updateNazione(input__nazione_acq, 'input__regione_acq', sezione_spedizione);

	if (OSC_FORM.length > 0) {
		osc();
	}

	OSC_SHIPMENT.on('change', shipmentChange);
	OSC_CAP.on('keyup', shipmentChange);
	OSC_STATE.on('change', shipmentChange);
	OSC_PAYMENT.on('change', paymentChange);
	OSC_GUEST.on('change', guestChange);

	shipmentChange();
	paymentChange();
}

const guestChange = function() {
	let requirePassword = OSC_GUEST;

	if (requirePassword.is(':checked')) {
		$('.input__pass').show();
		$('.input__pass input').addClass('input__required');
		$('.input__pass input').val('');
		$('.input__pass input').on('keyup', checkGuestPassword);
	} else {
		$('.input__pass').hide();
		$('.input__pass input').removeClass('input__required');
		$('.input__pass input').val('');
		$('.input__pass input').off('keyup');
	}
};

const checkGuestPassword = function() {
	if ($('input[name=guest_pass]').val() != $('input[name=guest_pass_confirm]').val()) {
		$('input[name=guest_pass_confirm]').addClass('input__error');
	} else {
		$('input[name=guest_pass_confirm]').removeClass('input__error');
	}
};

const paymentChange = function() {
	let paymentID = OSC_PAYMENT.filter(':checked').val();

	$.ajax({
		url: _url + 'ajax/ajax.order_actions.php',
		type: 'POST',
		data: {
			metodo_pagamento: paymentID,
			total: $('input[name=totale_articoli_scontato]').val(),
			spedizione: $('input[name=totale_spedizione]').val(),
			action: 'payment'
		},
		success: function(data) {
			if(data.maggiorazione > 0) {
				$('.r-maggiorazione .r-metodo').html(data.metodo);
				$('.r-maggiorazione .price').html(data.maggiorazione_visual);
				$('.r-maggiorazione').show();
			} else {
				$('.r-maggiorazione').hide();
				$('.r-maggiorazione .price').html('');
				$('.r-maggiorazione .r-metodo').html('');
			}

			$('input[name=totale_maggiorazione]').val(data.maggiorazione);
			orderTotal();
		}
	});
};

const shipmentChange = function() {
	let cap = OSC_CAP.val();
	let stateID = OSC_STATE.val();
	let shipmentID = OSC_SHIPMENT.filter(':checked').val();
	let cartID = OSC_CART.val();

	if(shipmentID == 2) {
		$('#dati-spedizione span.input:not(.shipment-method-choose)').hide();
		$('#dati-spedizione span.input:not(.shipment-method-choose) input.input__required').attr('oldreq', 1);
		$('#dati-spedizione span.input:not(.shipment-method-choose) input').val('');
		$('#dati-spedizione span.input:not(.shipment-method-choose) input.input__required').removeClass('input__required');
		$('#dati-spedizione span.input:not(.shipment-method-choose) select.input__required').attr('oldreq', 1);
		$('#dati-spedizione span.input:not(.shipment-method-choose) select').val('');
		$('#dati-spedizione span.input:not(.shipment-method-choose) select.input__required').removeClass('input__required');
	} else {
		$('#dati-spedizione span.input:not(.shipment-method-choose)').show();
		$('#dati-spedizione span.input:not(.shipment-method-choose) input[oldreq=1]').addClass('input__required');
		$('#dati-spedizione span.input:not(.shipment-method-choose) select[oldreq=1]').addClass('input__required');
	}

	$.ajax({
		url: _url + 'ajax/ajax.order_actions.php',
		type: 'POST',
		data: {
			order_id: cartID,
			cap: cap,
			nazione: stateID,
			shipment: shipmentID,
			action: 'shipment'
		},
		success: function(data) {
			OSC_CAP.removeClass('input__error');
			$('#cap-errato').hide();

			if(data.spese_spedizione === undefined) {
				data.spese_spedizione = 0;
			}

			if(data.not_found !== undefined) {
				data.spese_spedizione = 0;



				if(cap != ""){
					$('#cap-errato').show();
					OSC_CAP.addClass('input__error');
				}
				$('.r-spedizione').hide();
				$('.r-spedizione .price').html('');
			}
			else
			if(data.spese_spedizione > 0) {
				$('.r-spedizione .price').html(data.spese_spedizione_visual);
				$('.r-spedizione').show();
			} else {
				$('.r-spedizione').hide();
				$('.r-spedizione .price').html('');
			}

			$('input[name=totale_spedizione]').val(data.spese_spedizione);
			orderTotal();
		}
	});
};

const osc = function(event) {
	OSC_STEPS.on('click', toggleOscStep);
	OSC_SPLITPAY.on('change', splitPayment);
	OSC_UGUALI.on('change', gestisciDatiSpedizione);

  //tipoUtenteCheck.on('change', chooseUserType);
  //tipoUtenteCheck.trigger('change');

  tipoUtenteFatCheck.on('change', chooseUserFatType);
  tipoUtenteFatCheck.trigger('change');

  orderTotal();
};

const gestisciDatiSpedizione = function() {

	if(tipoUtenteFatCheck.filter(':checked').val() == "Privato"){
		$('input[name=fat_nome]').val($('input[name=acq_nome]').val());
		$('input[name=fat_cognome]').val($('input[name=acq_cognome]').val());
		$('input[name=fat_provincia]').val($('input[name=acq_provincia]').val());
		$('input[name=fat_indirizzo]').val($('input[name=acq_indirizzo]').val());
		$('input[name=fat_civico]').val($('input[name=acq_civico]').val());
		$('input[name=fat_cap]').val($('input[name=acq_cap]').val());
		$('input[name=fat_citta]').val($('input[name=acq_citta]').val());
		$('input[name=fat_telefono]').val($('input[name=acq_telefono]').val());
		$('select[name=fat_nazione]').val($('select[name=acq_nazione]').val());
		$('select[name=fat_italia]').val($('select[name=acq_regione]').val());

		$('select[name=fat_italia]').trigger('change');

	}else{

		if($('input[name=uguali]').is(':checked')) {
			$('input[name=acq_nome]').val($('input[name=fat_nome]').val());
			$('input[name=acq_cognome]').val($('input[name=fat_cognome]').val());
			$('input[name=acq_ragione_sociale]').val($('input[name=fat_ragione_sociale]').val());
			$('input[name=acq_provincia]').val($('input[name=fat_provincia]').val());
			$('input[name=acq_indirizzo]').val($('input[name=fat_indirizzo]').val());
			$('input[name=acq_civico]').val($('input[name=fat_civico]').val());
			$('input[name=acq_cap]').val($('input[name=fat_cap]').val());
			$('input[name=acq_citta]').val($('input[name=fat_citta]').val());
			$('input[name=acq_telefono]').val($('input[name=fat_telefono]').val());
			$('select[name=acq_nazione]').val($('select[name=fat_nazione]').val());
			$('select[name=acq_regione]').val($('select[name=fat_italia]').val());
		} else {
			$('input[name=acq_nome]').val('');
			$('input[name=acq_cognome]').val('');
			$('input[name=acq_ragione_sociale]').val('');
			$('input[name=acq_provincia]').val('');
			$('input[name=acq_indirizzo]').val('');
			$('input[name=acq_civico]').val('');
			$('input[name=acq_cap]').val('');
			$('input[name=acq_citta]').val('');
			$('input[name=acq_telefono]').val('');
			$('select[name=acq_nazione]').val('');
			$('select[name=acq_regione]').val('');
		}

		$('select[name=acq_nazione]').trigger('change');

	}


};

const splitPayment = function() {
	let _this = $(this);

	if(_this.is(':checked')) {
		$('.r-tot-split').html('(SPLIT PAYMENT)');
	} else {
		$('.r-tot-split').html('');
	}

	orderTotal();
};

const calcolaIva = function() {

	let totale_articoli = parseFloat($('input[name=totale_articoli_scontato]').val());
	let spedizione = parseFloat($('input[name=totale_spedizione]').val());
	let maggiorazione = parseFloat($('input[name=totale_maggiorazione]').val());
	let iva = 0

	if(!OSC_SPLITPAY.is(':checked')) {
		iva = Math.round(((totale_articoli + spedizione + maggiorazione) / 100 )* 22);
	}

	$('.r-tot-iva').html(formattaPrezzoEuro(iva));
	$('[name=totale_iva]').val(iva);

};

const orderTotal = function() {

	calcolaIva();

	let totale_articoli = $('input[name=totale_articoli_scontato]').val();
	let iva = $('input[name=totale_iva]').val();
	let sconto = $('input[name=totale_sconto]').val();
	let maggiorazione = $('input[name=totale_maggiorazione]').val();
	let spedizione = $('input[name=totale_spedizione]').val();

	let totale_ordine = 0;
	totale_ordine = Math.round(parseFloat(totale_articoli) + parseFloat(spedizione) + parseFloat(maggiorazione) + parseFloat(iva));

	$('.tot-ordine').html(formattaPrezzoEuro(totale_ordine));
	$('input[name=totale_ordine]').val(totale_ordine);

};

const toggleOscStep = function() {
	let _this = $(this);
	_this.toggleClass('open');

	if(_this.data('div') == "dati-spedizione") {
		if(primaVoltaCopia == 0) {
			gestisciDatiSpedizione();
			primaVoltaCopia++;
		}
	}

	if(_this.data('div') == "dati-pagamenti") {
		if($('select[name=acq_nazione]').val() != 1) {
			$('.pagamento7').hide();

			if($('input[name=metodo_pagamento]:checked').val() == 7) {
				$('.pagamento1 input[name=metodo_pagamento]').click();
			}


		} else {
			$('.pagamento7').show();
		}
	}


	$('#'+_this.data('div')).toggle();
	$('.c-togglable:not(#'+_this.data('div')+")").hide();
	$('.c-toggle-div:not([data-div='+_this.data('div')+"])").removeClass('open');


	$('html, body').animate({
		scrollTop: _this.offset().top - 100
	}, 500);


};

const chooseUserType = function() {
	let tipoUtente = tipoUtenteFatCheck.filter(':checked').val();
	let tipoUtenteEnemy = "";
	if(tipoUtente == "Privato") {
		tipoUtenteEnemy = "Azienda";
		piva.off('keypress');
		cfiscale.off('keypress');
	} else {
		tipoUtenteEnemy = "Privato";
		piva.off('keypress').on('keypress', preventChart);
		cfiscale.off('keypress').on('keypress', preventChart);
	}

	$('.input__'+tipoUtente).parent().show();
	$('.input__'+tipoUtente+":not(.input__required)").addClass('input__required');
	$('.input__'+tipoUtenteEnemy).parent().hide();
	$('.input__'+tipoUtenteEnemy).removeClass('input__required');
	$('.input__'+tipoUtenteEnemy).val('');

};

const chooseUserFatType = function() {



	let tipoUtente = tipoUtenteFatCheck.filter(':checked').val();
	let tipoUtenteEnemy = "";
	if(tipoUtente == "Privato") {
		tipoUtenteEnemy = "FatAzienda";

		$('#metodo_spedizione_1').trigger('click');
		$('#metodo_spedizione_2').parent().parent().hide();

		$('h3[data-div="dati-fatturazione"]:visible').hide();
		$('h3[data-div="dati-spedizione"]:not(.open)').addClass('open');
		$('#dati-fatturazione:visible').toggle();
		$('#dati-fatturazione .cfp input').removeClass('input__required');
		$('#dati-spedizione:hidden').toggle();
		$('.splitpayment').hide();
		$('#splitpayment').prop('checked', false);

		splitPayment();
		calcolaIva();

	} else {
		tipoUtenteEnemy = "FatPrivato";

		$('#metodo_spedizione_2').parent().parent().show();
		$('h3[data-div="dati-fatturazione"]:hidden').show();
		$('h3[data-div="dati-fatturazione"]:not(.open)').addClass('open');
		$('#dati-fatturazione:hidden').toggle();
		$('#dati-spedizione:visible').toggle();
		$('#dati-fatturazione .cfp input:not(.input__required)').addClass('input__required');
		$('h3[data-div="dati-spedizione"].open').removeClass('open');
		$('.splitpayment').show();

	}

	tipoUtente = "Fat"+tipoUtente;

	$('.input__'+tipoUtente).parent().show();
	$('.input__'+tipoUtente+":not(.input__required)").addClass('input__required');
	$('.input__'+tipoUtenteEnemy).parent().hide();
	$('.input__'+tipoUtenteEnemy).removeClass('input__required');
	$('.input__'+tipoUtenteEnemy).parent().removeClass('input--filled');
	$('.input__'+tipoUtenteEnemy).val('');

};

/**
 * [isResponsive description]
 * @return {Boolean} [description]
 */
 const isResponsive = function() {
 	return screen.width <= 768;
 };

/**
 * [isResponsive description]
 * @return {Boolean} [description]
 */
 const showObjCSS = function() {
 	return {'display': 'block', 'visibility': 'visible'};
 };

/**
 * [isResponsive description]
 * @return {Boolean} [description]
 */
 const hideObjCSS = function(force = false) {
 	return {'display': ((force || isResponsive()) ? 'none' : 'block'), 'visibility': 'hidden'};
 };

/**
 * [updateNazione description]
 * @param {[type]} _input [description]
 * @param {[type]} className [description]
 * @param {[type]} section [description]
 * @return {[type]} [description]
 */
 const updateNazione = function(_input, className, section = null) {
 	let input__regione = $('.' + className);

 if ($(_input).val() == '1') { // La nazione scelta è 'Italia'
 input__regione.closest('span').css(showObjCSS());
if (section !== null && section.css('display') != 'none') {
	input__regione.addClass('input__required');
}
} else {
	input__regione.closest('span').css(hideObjCSS(!input__regione.closest('span').next().hasClass('input')));
	input__regione.removeClass('input__required');
}
};

/**
 * [enableSplitPayment description]
 * @param {[type]} _input [description]
 * @return {[type]} [description]
 */
 const enableSplitPayment = function(_input) {
 	let input__splitpayment = $('.splitpayment');

 if ($(_input).val() == '1') { // La nazione scelta è 'Italia'
 input__splitpayment.closest('span').css(showObjCSS());
} else {
	input__splitpayment.closest('span').css(hideObjCSS(true));
}
}

/**
 * [enableSplitPayment description]
 * @param {[type]} _input [description]
 * @return {[type]} [description]
 */
 const enableFatturazione = function(_input) {
 	let input__pec = $('.input__pec');
 	let input__cd = $('.input__codice_destinatario');

 	let input_label__pec = input__pec.parent().find('.input__label .input__label-content');
 	let input_label__cd = input__cd.parent().find('.input__label .input__label-content');

 	let text_pec = input_label__pec.text();
 	let text_cd = input_label__cd.text();

 if ($(_input).val() == '1') { // La nazione scelta è 'Italia'
 input__pec.addClass('input__required');
input__cd.addClass('input__required');

if (text_pec.indexOf('*') == -1) {
	input_label__pec.attr('data-content', text_pec + '*');
	input_label__pec.text(text_pec + '*');
}

if (text_cd.indexOf('*') == -1) {
	input_label__cd.attr('data-content', text_cd + '*');
	input_label__cd.text(text_cd + '*');
}
} else {
	input__pec.removeClass('input__required');
	input__cd.removeClass('input__required');

	let new_text_pec = text_pec.replace('*', '');
	let new_text_cd = text_cd.replace('*', '');

	input_label__pec.attr('data-content', new_text_pec);
	input_label__pec.text(new_text_pec);

	input_label__cd.attr('data-content', new_text_cd);
	input_label__cd.text(new_text_cd);
}
}

let hideWarning = function(event) {
	warning_modal.hide();
	warning_modal.addClass('already-saw');
}

let preventChart = function(event) {
	if (event.which < 48 || event.which > 57) {
		event.preventDefault();
	}
}

let toggleDestinatario = function(event) {
	sezione_spedizione.toggle();

	required = OSC_FORM.find('.input_will_be_required');
	required.each(function() {
		_this = $(this);

		if (!_this.hasClass('input__regione_acq')) {
			_this.toggleClass('input__required');
		}
	});

	updateNazione(input__nazione_acq, 'input__regione_acq', sezione_spedizione);
}

let checkToProceed = function(event) {
	var errore = 0;
	var showpopup = 0;

	var condizioni = OSC_FORM.find('#condizioni');
	var articoli = OSC_FORM.find('#articoli');
	var errore = 0;

	let tipoUtente = tipoUtenteFatCheck.filter(':checked').val();

	if(tipoUtente == "Privato"){
		$('input[name=fat_nome]').val($('input[name=acq_nome]').val());
		$('input[name=fat_cognome]').val($('input[name=acq_cognome]').val());
		$('input[name=fat_provincia]').val($('input[name=acq_provincia]').val());
		$('input[name=fat_indirizzo]').val($('input[name=acq_indirizzo]').val());
		$('input[name=fat_civico]').val($('input[name=acq_civico]').val());
		$('input[name=fat_cap]').val($('input[name=acq_cap]').val());
		$('input[name=fat_citta]').val($('input[name=acq_citta]').val());
		$('input[name=fat_telefono]').val($('input[name=acq_telefono]').val());
		$('select[name=fat_nazione]').val($('select[name=acq_nazione]').val());
		$('select[name=fat_italia]').val($('select[name=acq_regione]').val());

		$('select[name=fat_italia]').trigger('change');
	}

	OSC_FORM.find('.condizioni').css({
		'color' : '#37393b'
	});

	OSC_FORM.find('.articoli').css({
		'color' : '#37393b'
	});

	if (!condizioni.is(':checked')) {
		errore = 1;
		OSC_FORM.find('.condizioni').css({
			'color' : 'red'
		});
	}

	if (!articoli.is(':checked')) {
		errore = 1;
		OSC_FORM.find('.articoli').css({
			'color' : 'red'
		});
	}

	required = OSC_FORM.find('.input__required');

	required.each(function() {
		_this = $(this);

		_this.removeClass('input__error');
		_this.closest('span').removeClass('input__check-error');
		_this.parent().find('a').removeClass('input__check-error');

		nome = _this.attr('name');
		tipo = _this.attr('type');
		valore = _this.val();

		if (_this.data('otherwise')) {
			let _other = OSC_FORM.find('.input__field[name="' + _this.data('otherwise') + '"]');
			let _otherValore = _other.val();

			let checkThisValore = (valore == '' && valore.replace(' ', '') == '');
			let checkOtherValore = (_otherValore == '' && _otherValore.replace(' ', '') == '');

			if ((checkThisValore && checkOtherValore)) {
				errore = 1;

				if (checkThisValore) {
					_this.addClass('input__error');
				}
			}
		} else if(tipo == 'text') {
			if(valore.trim() == '') {
				errore= 1;
				_this.addClass('input__error');
			}

			if(tipoUtente == "Privato") {
				if( ( nome == 'fat_cod_fiscale' ) && (valore.length != 16 ) ) {
					showpopup= 1;
				}
			}else
			if(tipoUtente == "Azienda") {
				if( ( nome == 'fat_cod_fiscale' || nome == 'fat_piva' ) && (valore.length != 11 ) ) {
					showpopup= 1;
				}
			}
		} else if(tipo == 'number') {
			if(valore.trim() && !$.isNumeric(valore)) {
				errore= 1;
				_this.addClass('input__error');
			}
		} else if(tipo == 'email') {
			if(isEmail(valore)) {
				if(nome == 'acc_mail') {
					confronto_email= valore;
				} else if(nome == 'acc_conferma_mail') {
					if( confronto_email != valore ) {
						_this.addClass('input__error');
						errore= 1;
					}
				}
			} else {
				_this.addClass('input__error');
				errore=1;
			}
		} else if(tipo == 'password') {
			if(nome == 'guest_pass') {
				confronto_pass= valore;
			} else if(nome == 'guest_pass_confirm') {
				if( confronto_pass != valore ) {
					_this.addClass('input__error');
					errore= 1;
				}
			}
		} else if(tipo == 'checkbox') {
			if(!_this.is(':checked')) {
				_this.closest('span').addClass('input__check-error');
				_this.parent().find('a').addClass('input__check-error');
				errore= 1;
			}
		} else if( tipo == undefined ) {
			if( valore == '' ) {
				_this.addClass('input__error');
				errore= 1;
			}
		}
	});

	let paymentMethod = '';
	switch(parseInt($('input[name="metodo_pagamento"]:checked').val())) {
		case 1:
		paymentMethod = 'Carta di credito / Postepay';
		break;
		case 5:
		paymentMethod = 'Bonifico Bancario';
		break;
		case 6:
		paymentMethod = 'Paypal';
		break;
		case 7:
		paymentMethod = 'Contrassegno';
		break;
	}

	if($('input[name="metodo_pagamento"]:checked').val() === undefined){
		$('h3[data-div="*"].open').click();
		$('h3[data-div="dati-pagamenti"]:not(.open)').click();
		$('#dati-pagamenti').css('color','red');
		errore= 1;
	}else{
		$('#dati-pagamenti').css('color','#37393b');
	}

	let shipmentID = OSC_SHIPMENT.filter(':checked').val();

	let shippingMethod = '';
	if (shipmentID == 1) {
		shippingMethod = 'Corriere';
	} else if (shipmentID == 2) {
		shippingMethod = 'Ritiro in sede';
	}

	let checkout = {
		'currencyCode': 'EUR',
		'checkout': {
			'actionField': {
				'step': 2,
				'option': paymentMethod,
				'shipping': parseFloat($('input[name=totale_iva]').val() / 100).toFixed(2),
				'tax': parseFloat($('input[name=totale_spedizione]').val() / 100).toFixed(2)
			}
		}
	};

	let option = {
		'currencyCode': 'EUR',
		'checkout_option': {
			'actionField': {
				'step': 2,
				'option': shippingMethod
			}
		},
	};

	let callback = function() {
		$.ajax({
			url: _url + 'ajax/ajax.order_actions.php',
			type: 'POST',
			data: OSC_FORM.serialize()+"&action=set_in_session",
			success: function(data) {
				OSC_FORM.submit();
			}
		});
	};

	if (errore == 0) {
		if (showpopup == 0) {
			window.dataLayer.push({
				'event': 'checkout',
				'ecommerce': checkout
			});
			window.dataLayer.push({
				'event': 'checkout_option',
				'ecommerce': option
			});

			callback();
		} else {
			if (warning_modal.hasClass('already-saw')) {
				window.dataLayer.push({
					'event': 'checkout',
					'ecommerce': checkout
				});
				window.dataLayer.push({
					'event': 'checkout_option',
					'ecommerce': option
				});

				callback();
			} else {
				warning_modal.toggle();
			}
		}
	} else {
		//$('html, body').animate({scrollTop:0},300);
	}
}

let toggleSection = function(event) {
	$('.check-form').toggleClass('open--form');
}

const formattaPrezzoEuro = function(prezzo) {
	prezzo = prezzo/100;
	var prezzoFormattato = prezzo.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
	prezzoFormattato = prezzoFormattato.replace(",",":");
	prezzoFormattato = prezzoFormattato.replace(".",",");
	prezzoFormattato = prezzoFormattato.replace(":",".");
	return "&euro; "+prezzoFormattato;
};



// WEBPACK FOOTER //
// ./src/js/modules/ordine.js